import { getListViewStore } from '../store/Store';

export default function getItemIdsOfConversation(conversationId: string): string[] {
    const { conversationItems } = getListViewStore();
    const conversationItem = conversationItems?.get(conversationId);

    return conversationItem.globalItemIds || [];
}
